export default {
    "welcome": {
        "title": "Vítejte v ProcrastiQ",
        "subtitle": "Váš produktivní parťák",
        "modal": {
            "title": "Vítejte v ProcrastiQ",
            "headline": "Chytřejší přestávky začínají tady",
            "subheading": "Krátké výzvy, zajímavosti a mozkové jednohubky, které promění pár volných minut v něco smysluplného.",
            "text": "Procrastiq je místo, kde se z obyčejné prokrastinace stává něco smysluplného. Místo nekonečného scrollování sociálních sítí na vás čekají krátké mozkové výzvy které procvičí mysl a možná vás naučí i něco nového.\n\nKaždý potřebuje občas vypnout, odpočinout si a na chvíli utéct od práce. Procrastiq vám pomůže využít tyto drobné přestávky lépe — s trochou zvědavosti, radosti a každodenního tréninku mozku. \n\nMalé výzvy. Velký pokrok.",
            "cta": "Jdeme na to"
        }
    },
    "login": {
        "title": "Přihlášení",
        "email": "E‑mail",
        "password": "Heslo",
        "submit": "Přihlásit se",
        "cancel": "Zrušit",
        "success": "Přihlášení úspěšné",
        "lead": "Vítej zpět — pokračuj ve sérii a stoupej v ligách."
    },
    "auth": {
        "bot_required": "Dokonči prosím bezpečnostní kontrolu."
    },
    "logout": "Odhlásit",
    "register": {
        "title": "Registrace",
        "name": "Jméno",
        "email": "E‑mail",
        "password": "Heslo",
        "submit": "Vytvořit účet",
        "cancel": "Zrušit",
        "success": "Registrace úspěšná",
        "country": "Země",
        "lead": "Založ účet, sbírej XP, odemykej hodnosti a zapoj se do týdenních lig."
    },
    "social": {
        "divider": "Nebo pokračujte přes",
        "signInWith": "Přihlásit se přes {{provider}}",
        "continueWith": "Pokračovat přes {{provider}}",
        "failed": "Přihlášení přes sociální síť selhalo",
        "popup_blocked": "Vyskakovací okno bylo zablokováno. Povolte pop-up okna a zkuste to znovu.",
        "cancelled": "Přihlášení bylo zrušeno."
    },
    "common": {
        "cancel": "Zrušit",
        "saving": "Ukládání...",
        "unknown_error": "Neznámá chyba",
        "select_country": "Vyberte zemi",
        "select_option": "Vyberte možnost",
        "search": "Hledat…",
        "no_options": "Žádné možnosti",
        "country": "Země"
    },
    "language": {
        "page_language": "Jazyk stránek",
        "switch_to": "Přepnout na {{language}}"
    },
    "cookies": {
        "title": "Cookies",
        "message": "Používáme cookies pro analytiku (Google Analytics), abychom mohli Procrastiq zlepšovat.",
        "privacy_link": "Ochrana soukromí",
        "accept": "Souhlasím",
        "reject": "Odmítnout"
    },
    "footer": {
        "columns": {
            "about": {
                "title": "O nás",
                "mission": "Poslání",
                "progression": "XP, úrovně a ligy",
                "creator_progression": "Tvůrčí XP a hodnosti",
                "contact": "Kontaktujte nás"
            },
            "leaderboards": {
                "title": "Žebříčky",
                "players": "Členové",
                "creators": "Přispěvatelé"
            },
            "legal": {
                "title": "Soukromí a podmínky",
                "community": "Zásady komunity",
                "terms": "Podmínky služby",
                "privacy": "Ochrana soukromí"
            },
            "social": {
                "title": "Sociální sítě",
                "facebook": "Facebook",
                "instagram": "Instagram"
            }
        }
    },
    "pages": {
        "mission": {
            "title": "Poslání",
            "content": "ProcrastiQ proměňuje malé přestávky ve smysluplné chvíle — mozkové jednohubky, hádanky a mindful pauzy, které baví a stimulují vaši mysl.\n\nVěříme, že prokrastinace nemusí být ztracený čas. Každý si zaslouží chvíli na odpočinek a my pomáháme, aby tyto chvíle byly pozitivní, zvídavé a zábavné."
        },
        "contact": {
            "title": "Kontaktujte nás",
            "content": "Máte dotaz, nápad na zlepšení nebo jste narazili na něco, co nefunguje tak, jak má? Ozvěte se nám — každá zpětná vazba nám pomáhá Procrastiq dál zlepšovat.\n\nNapsat nám můžete na:\n\nhello@procrastiq.com\n\nRádi si přečteme také vaše návrhy na nový obsah, funkce nebo témata, která byste na Procrastiq chtěli vidět."
        },
        "community": {
            "title": "Zásady komunity",
            "content": "ProcrastiQ je přívětivé místo pro zvídavé lidi. Buďte respektující, laskaví a konstruktivní ve svých interakcích.\n\nNezveřejňujte škodlivý, urážlivý nebo spamový obsah. Nahlaste cokoli, co sem nepatří. Společně udržíme toto místo pozitivní pro učení a chytré přestávky."
        },
        "terms": {
            "title": "Podmínky služby",
            "content": "**Poslední aktualizace: 7. září 2026**\n\nPoužíváním služby Procrastiq souhlasíte s těmito podmínkami. Pokud s nimi nesouhlasíte, službu prosím nepoužívejte.\n\n## 1. O službě Procrastiq\n\nProcrastiq je online platforma zaměřená na vzdělávání, kvízy, hádanky a další interaktivní obsah.\n\nObsah služby slouží především pro vzdělávání a zábavu. Není určen jako odborné, právní, zdravotní, finanční ani jiné profesionální poradenství.\n\n## 2. Uživatelský účet\n\nNěkteré funkce Procrastiq mohou vyžadovat vytvoření uživatelského účtu.\n\nUživatel odpovídá za správnost údajů uvedených ve svém účtu a za zabezpečení svých přihlašovacích údajů.\n\nÚčet nesmí být používán k porušování práv jiných osob, zákonů ani těchto podmínek.\n\n## 3. Pravidla používání\n\nPři používání Procrastiq není dovoleno zejména:\n\n* zveřejňovat nezákonný, podvodný, nenávistný nebo jinak závadný obsah,\n* porušovat autorská nebo jiná práva třetích osob,\n* obtěžovat ostatní uživatele,\n* pokoušet se narušit zabezpečení nebo fungování služby,\n* automatizovaně získávat obsah nebo data způsobem, který nepovolujeme,\n* zneužívat systém hodnocení, XP, žebříčky nebo jiné herní mechanismy.\n\n## 4. Uživatelský obsah\n\nUživatelé mohou mít možnost vytvářet nebo zasílat vlastní obsah, například kvízy, otázky, komentáře nebo jiné příspěvky.\n\nOdesláním obsahu potvrzujete, že máte právo jej zveřejnit.\n\nAutorovi zůstávají práva k jeho obsahu. Zároveň nám poskytuje nevýhradní oprávnění tento obsah ukládat, zobrazovat, technicky upravovat a zpřístupňovat v rámci Procrastiq v rozsahu potřebném pro provoz služby.\n\n## 5. Moderace obsahu\n\nUživatelský obsah můžeme kontrolovat a v případě porušení těchto podmínek nebo platných právních předpisů jej odmítnout, skrýt nebo odstranit.\n\nV závažných nebo opakovaných případech můžeme omezit nebo zrušit uživatelský účet.\n\nPokud je to vzhledem k okolnostem možné a vyžadované právními předpisy, uživatele o důvodu takového rozhodnutí informujeme.\n\n## 6. Obsah Procrastiq\n\nObsah publikovaný přímo společností Procrastiq může obsahovat chyby nebo nepřesnosti. Přestože se snažíme informace kontrolovat a průběžně zlepšovat, nemůžeme zaručit jejich úplnost nebo bezchybnost.\n\nKvízy a další vzdělávací obsah mají především informační a zábavní charakter.\n\n## 7. Dostupnost služby\n\nSnažíme se udržovat Procrastiq dostupný a funkční, nemůžeme však zaručit nepřetržitý nebo bezchybný provoz.\n\nSlužbu můžeme průběžně měnit, rozšiřovat nebo některé její části ukončit.\n\n## 8. Odpovědnost\n\nV rozsahu povoleném platnými právními předpisy neneseme odpovědnost za škody vzniklé v důsledku nesprávného použití služby nebo spoléhání se na obsah, který má pouze informační či vzdělávací charakter.\n\nTím nejsou dotčena práva uživatelů, která nelze podle platných právních předpisů omezit.\n\n## 9. Ochrana osobních údajů\n\nInformace o tom, jak zpracováváme osobní údaje, naleznete v našich [Zásadách ochrany osobních údajů](/legal/privacy).\n\n## 10. Změny podmínek\n\nTyto podmínky můžeme čas od času aktualizovat například kvůli změnám služby, právních předpisů nebo způsobu fungování Procrastiq.\n\nDatum poslední aktualizace bude vždy uvedeno v horní části této stránky. O významných změnách můžeme uživatele informovat také přímo prostřednictvím služby nebo e-mailem.\n\n## 11. Kontakt\n\nMáte-li otázky týkající se těchto podmínek, můžete nás kontaktovat na:\n\n[hello@procrastiq.com](mailto:hello@procrastiq.com)"
        },
        "privacy": {
            "title": "Ochrana soukromí",
            "content": "**Poslední aktualizace: 7. září 2026**\n\nVaše soukromí bereme vážně. Níže vysvětlujeme, jaké osobní údaje při používání Procrastiq zpracováváme, proč je potřebujeme a jaká máte práva.\n\n## 1. Kdo údaje zpracovává\n\nSprávcem osobních údajů je:\n\n**Michal Orlík**\nfyzická osoba\n\nKontakt pro otázky týkající se ochrany osobních údajů:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\n## 2. Jaké údaje zpracováváme\n\nV závislosti na tom, jak Procrastiq používáte, můžeme zpracovávat zejména:\n\n* údaje o vašem účtu, například jméno, uživatelské jméno a e-mailovou adresu,\n* údaje získané při přihlášení prostřednictvím externí služby, například Google,\n* informace o používání služby, například zobrazený obsah, výsledky kvízů, získané XP, streaky, reakce, záložky a aktivitu ve feedu,\n* obsah, který sami vytvoříte nebo odešlete,\n* technické údaje, například IP adresu, typ zařízení, prohlížeč a informace potřebné pro zabezpečení a správné fungování služby.\n\n## 3. Proč údaje používáme\n\nOsobní údaje používáme zejména k tomu, abychom:\n\n* mohli vytvořit a spravovat váš účet,\n* mohli poskytovat funkce Procrastiq,\n* ukládali váš postup, výsledky, XP a další aktivitu,\n* přizpůsobovali obsah a doporučení,\n* chránili službu před zneužitím,\n* řešili chyby a technické problémy,\n* komunikovali s vámi,\n* analyzovali a zlepšovali fungování služby.\n\n## 4. Právní základ zpracování\n\nÚdaje zpracováváme podle konkrétního účelu zejména:\n\n* protože jsou nezbytné pro poskytování služby,\n* na základě našeho oprávněného zájmu na zabezpečení a zlepšování Procrastiq,\n* na základě vašeho souhlasu tam, kde je souhlas vyžadován,\n* případně z důvodu plnění právních povinností.\n\nPokud je zpracování založeno na souhlasu, můžete jej kdykoli odvolat.\n\n## 5. Komu mohou být údaje předány\n\nVaše osobní údaje neprodáváme.\n\nPro provoz služby však můžeme využívat externí poskytovatele, například pro:\n\n* hosting a infrastrukturu,\n* přihlašování uživatelů,\n* odesílání e-mailů a notifikací,\n* analytiku a diagnostiku chyb.\n\nTito poskytovatelé mohou údaje zpracovávat pouze v rozsahu potřebném k poskytování jejich služeb.\n\n## 6. Jak dlouho údaje uchováváme\n\nÚdaje spojené s vaším účtem zpravidla uchováváme po dobu existence účtu a následně po dobu nezbytnou pro splnění právních povinností nebo ochranu našich oprávněných zájmů.\n\nTechnické a analytické údaje uchováváme pouze po dobu potřebnou pro jejich účel.\n\n## 7. Vaše práva\n\nV souvislosti se zpracováním osobních údajů máte podle okolností právo:\n\n* získat informace o tom, jaké údaje o vás zpracováváme,\n* požádat o opravu nepřesných údajů,\n* požádat o výmaz údajů,\n* požádat o omezení jejich zpracování,\n* vznést námitku proti některým způsobům zpracování,\n* získat své údaje v přenositelném formátu,\n* odvolat udělený souhlas.\n\nPožadavek můžete zaslat na:\n\n**[hello@procrastiq.com](mailto:hello@procrastiq.com)**\n\nNa žádosti odpovídáme v souladu s platnými právními předpisy.\n\n## 8. Smazání účtu\n\nPokud služba umožňuje smazání účtu, můžete o jeho odstranění požádat přímo v nastavení účtu nebo nás kontaktovat na **[hello@procrastiq.com](mailto:hello@procrastiq.com)**.\n\nSmazáním účtu odstraníme nebo anonymizujeme osobní údaje, které již nemusíme uchovávat z právních nebo bezpečnostních důvodů.\n\n## 9. Cookies a podobné technologie\n\nProcrastiq může používat cookies a podobné technologie potřebné pro přihlášení, zabezpečení, ukládání nastavení a případně analytiku.\n\nPodrobnější informace o cookies mohou být uvedeny v samostatných zásadách používání cookies.\n\n## 10. Zabezpečení\n\nPoužíváme přiměřená technická a organizační opatření k ochraně osobních údajů před neoprávněným přístupem, ztrátou nebo zneužitím.\n\nŽádný systém však nelze považovat za absolutně bezpečný.\n\n## 11. Stížnost\n\nPokud máte za to, že s vašimi osobními údaji nakládáme v rozporu s právními předpisy, můžete se obrátit také na příslušný dozorový úřad.\n\nV České republice je jím **Úřad pro ochranu osobních údajů**.\n\n## 12. Změny těchto zásad\n\nTyto zásady můžeme čas od času aktualizovat, například v souvislosti s novými funkcemi nebo změnami právních předpisů.\n\nDatum poslední aktualizace vždy uvedeme v horní části této stránky."
        },
        "progression": {
            "title": "XP, úrovně a ligy",
            "content": "ProcrastiQ odměňuje zvědavost. Odpovídejte na kvízy, budujte sérii a postupujte od lehké zábavy až k týdenní soutěži.\n\n## Zkušenostní body (XP)\n\nTrvalé XP získáváte za dobrou hru — například správné odpovědi, bonus za první pokus, těžší otázky, procvičení chyb a denní cíle. Trvalé XP se nikdy neresetuje a vždy počítá do vaší úrovně.\n\nExistuje také soutěžní XP jen pro týdenní ligy. Soutěžní XP má během dne klesající výnosy: dřívější XP se počítá naplno, pozdější méně. Díky tomu je soutěž férovější, i když někdo hraje celý den.\n\n## Úrovně\n\nÚroveň vychází z celkového trvalého XP. Každá další úroveň potřebuje o něco víc XP než předchozí, aby byl postup pořád smysluplný.\n\nV profilu vidíte, kolik XP máte v aktuální úrovni a kolik zbývá do další.\n\n## Hodnosti\n\nHodnosti jsou tituly odemčené podle úrovně. Jsou odznakem vašeho pokroku — odděleně od týdenních ligových úrovní.\n\n- Úroveň 1 — Zvědavá mysl\n- Úroveň 3 — Průzkumník\n- Úroveň 5 — Badatel\n- Úroveň 8 — Řešitel\n- Úroveň 12 — Analytik\n- Úroveň 18 — Logik\n- Úroveň 25 — Stratég\n- Úroveň 35 — Polyhistor\n- Úroveň 50 — Génius\n- Úroveň 70 — Mistr poznání\n- Úroveň 100 — Legenda Procrastiq\n\n## Týdenní ligy\n\nLigy jsou týdenní soutěž s ostatními hráči ve skupinách asi po 20.\n\nÚrovně od nejnižší po nejvyšší:\n\n- Železná\n- Bronzová\n- Stříbrná\n- Zlatá\n- Platinová\n- Diamantová\n- Mistrovská\n- Legendární\n\nKaždý týden soutěžíte v rámci své skupiny o soutěžní XP. Na konci týdne zhruba nejlepší hráči postoupí o úroveň výš a nejhorší sestoupí. Ostatní zůstávají.\n\nNemusíte čekat na pondělní reset. Jakmile splníte podmínky, dostanete se do otevřené skupiny hned — nebo se pro vás vytvoří nová.\n\nPro odemčení lig obvykle potřebujete:\n\n- alespoň 100 trvalého XP\n- alespoň 10 dokončených aktivit\n- aktivitu alespoň ve 2 různých dnech\n- zapnuté zobrazování v žebříčcích u profilu\n\nKdykoli otevřete Žebříček nebo panel statistik a uvidíte svou ligu, pozici a skupinu."
        },
        "creator_progression": {
            "title": "Tvůrčí XP a hodnosti",
            "content": "Tvorba obsahu na ProcrastiQ má vlastní postup — úplně oddělený od hráčského XP, úrovní a týdenních lig.\n\nKdyž lidem chutnají vaše kvízy a mozkové jednohubky, získáváte tvůrčí XP (CXP). CXP odemyká tvůrčí hodnosti a řadí vás na žebříčky Přispěvatelů.\n\n## Dva nezávislé systémy\n\n- Hráčský postup — XP za hraní, úrovně, tituly, týdenní ligy\n- Tvůrčí postup — CXP za kvalitní příspěvky, tvůrčí hodnosti, žebříčky Přispěvatelů\n\nHraní nezvyšuje tvůrčí hodnost. Tvorba nezvyšuje hráčskou úroveň. Oba tracky můžete růst najednou.\n\n## Jak se získává tvůrčí XP\n\nCXP se uděluje za schválené příspěvky a za engagement na tomto obsahu — ne za počet odeslaných draftů.\n\nTypické odměny:\n\n- Schválený obsah — +20 CXP (jednou za položku)\n- Každých 10 dokončení vašeho obsahu — +2 CXP\n- Každých 10 lajků — +5 CXP\n- Každých 10 záložek — +2 CXP\n\nZobrazení a další statistiky se na tvůrčím profilu sledují, ale CXP dávají jen odměny výše. Hodnoty se mohou časem upravit.\n\n## Tvůrčí hodnosti\n\nHodnost vychází z celkového CXP. Prahy rostou zhruba exponenciálně — začátek je rychlý, vyšší hodnosti zůstávají výzvou.\n\n- 0 CXP — Přispěvatel\n- 50 CXP — Tvůrce\n- 150 CXP — Autor\n- 400 CXP — Expert\n- 1 000 CXP — Mentor\n- 2 500 CXP — Mistr tvůrce\n- 6 000 CXP — Procrastiq Mudrc\n\nV profilu vidíte aktuální hodnost, CXP a postup k další hodnosti.\n\n## Žebříčky Přispěvatelů\n\nTvůrci se řadí podle tvůrčího XP, ne podle počtu odeslaných položek.\n\n- Týdenní — CXP získané tento týden\n- Měsíční — CXP získané tento měsíc\n- Celkově — celkové CXP\n\nOtevřete Žebříčky a přepněte na Přispěvatele, abyste viděli, kdo stoupá."
        }
    },
    "account": {
        "profile_picture": "Profilová fotografie",
        "save_changes": "Uložit změny",
        "update_success": "Profil byl úspěšně aktualizován",
        "update_failed": "Nepodařilo se aktualizovat profil",
        "country": "Země",
        "avatar": {
            "upload_label": "Nahrát avatar",
            "upload_success": "Avatar byl úspěšně nahrán",
            "upload_failed": "Nahrávání avataru se nezdařilo",
            "delete_confirm": "Opravdu chcete smazat svůj avatar?",
            "delete_success": "Avatar byl úspěšně smazán",
            "delete_failed": "Smazání avataru se nezdařilo"
        },
        "password": {
            "set_optional": "Nastavit heslo (volitelné)",
            "change_optional": "Změnit heslo (volitelné)",
            "oauth_info": "Přihlásili jste se přes {{method}}. Volitelně si můžete nastavit heslo pro přihlášení e‑mailem/heslem.",
            "current": "Současné heslo",
            "current_placeholder": "Zadejte současné heslo",
            "current_required": "Pro změnu hesla je vyžadováno současné heslo",
            "new": "Nové heslo",
            "set_placeholder": "Nastavte heslo",
            "leave_blank_placeholder": "Ponechte prázdné pro zachování",
            "confirm": "Potvrzení nového hesla",
            "confirm_placeholder": "Potvrďte nové heslo",
            "mismatch": "Nová hesla se neshodují"
        }
    },
    "play": {
        "label": "Play",
        "games": {
            "memory": "Paměť",
            "focus": "Fokus",
            "sequence": "Sekvence",
            "reflex": "Reflex"
        },
        "memory": {
            "hint_preview": "Zapamatuj si zvýrazněná pole.",
            "hint_input": "Klepni na pole, která sis zapamatoval/a.",
            "cell": "Pole {{n}}"
        },
        "focus": {
            "hint": "Najdi odlišný symbol."
        },
        "sequence": {
            "title": "Zapamatuj si sekvenci",
            "countdown_hint": "Připrav se — sekvence za chvíli začne.",
            "go": "Teď!",
            "hint_watch": "Sleduj pozorně.",
            "hint_input": "Teď sekvenci zopakuj."
        },
        "reflex": {
            "hint": "Vyber barvu textu, ne slovo.",
            "progress": "{{current}} / {{total}}"
        },
        "colors": {
            "red": "ČERVENÁ",
            "blue": "MODRÁ",
            "green": "ZELENÁ",
            "orange": "ORANŽOVÁ"
        },
        "result": {
            "success": "Super!",
            "fail": "✗ Špatně."
        }
    },
    "pause": {
        "label": "Pauza",
        "types": {
            "breathing": "Dýchání",
            "eyes": "Odpočinek očí",
            "stretch": "Krátký stretch",
            "grounding": "Reset"
        },
        "skip": "Přeskočit",
        "continue": "Pokračovat",
        "breathing": {
            "inhale": "Nádech",
            "exhale": "Výdech"
        },
        "eyes": {
            "step_far": "Podívej se na něco dál od obrazovky.",
            "step_blink": "Uvolni oči a několikrát pomalu zamrkej.",
            "step_close": "Na chvíli zavři oči."
        },
        "stretch": {
            "step_shoulders": "Spusť ramena a nech je uvolněná.",
            "step_sit": "Sedni si o něco vzpřímeněji a uvolni záda.",
            "step_roll": "Pomalu zakruž rameny."
        },
        "grounding": {
            "prompt_color": "Najdi kolem sebe 3 věci stejné barvy.",
            "prompt_sounds": "Všimni si 2 různých zvuků kolem sebe.",
            "prompt_look_away": "Na chvíli se podívej pryč od obrazovky.",
            "prompt_texture": "Dotkni se něčeho poblíž a vnímej jeho texturu.",
            "prompt_breath": "Udělej jeden pomalý nádech a vnímej chodidla na zemi.",
            "prompt_feet": "Jemně zatlač chodidla do podlahy a vnímej kontakt."
        },
        "result": {
            "done": "Hotovo"
        }
    },
    "content": {
        "loading": "Načítání...",
        "no_content": "Zatím žádný obsah.",
        "feed_exhausted_tag": "Pro tento štítek jste si již vše zodpověděli",
        "feed_exhausted_category": "Pro tuto kategorii jste si již vše zodpověděli",
        "browse_feed": "Prohlédnout obsah",
        "back_to_feed": "← Zpět na přehled",
        "back": "← Zpět",
        "content_not_found": "Obsah nenalezen",
        "failed_load": "Nepodařilo se načíst obsah",
        "failed_load_more": "Nepodařilo se načíst další",
        "list": {
            "showing": "Zobrazeno {{count}} z {{total}}",
            "load_more": "Načíst další"
        },
        "answer": {
            "your_answer": "Vaše odpověď...",
            "your_result_or_answer": "Váš výsledek nebo odpověď...",
            "select_or_type": "Vyberte odpověď...",
            "fill_in_blank": "Doplňte chybějící slovo...",
            "your_answer_flip": "Vaše odpověď (nebo otočte pro kontrolu)...",
            "reveal_answer": "Zobrazit odpověď",
            "self_check_prompt": "Věděli jste to?",
            "knew_it": "Věděl/a jsem",
            "need_practice": "Potřebuji procvičit",
            "check": "Zkontrolovat",
            "completed": "Hotovo",
            "completing": "Ukládám...",
            "skip": "Přeskočit",
            "next": "Další",
            "checking": "Kontroluji...",
            "correct": "✓ Správně!",
            "not_quite": "✗ Skoro.",
            "correct_answer": "Správná odpověď: {{answer}}"
        },
        "stats": {
            "sign_in_to_react": "Přihlaste se pro lajk/dislajk",
            "bookmark": "Uložit",
            "remove_bookmark": "Odebrat záložku",
            "save_for_later": "Uložit na později",
            "saved": "Uloženo",
            "share": "Sdílet",
            "link_copied": "Odkaz zkopírován do schránky",
            "share_failed": "Kvíz se nepodařilo sdílet",
            "completions": "Dokončeno: {{count}}",
            "aria_like": "Lajk",
            "aria_dislike": "Dislajk"
        },
        "admin": {
            "edit": "Upravit",
            "delete": "Smazat",
            "stats": "Statistiky",
            "stats_title": "Statistiky obsahu",
            "delete_confirm": "Smazat „{{title}}“?",
            "deleted": "Obsah smazán",
            "delete_failed": "Nepodařilo se smazat obsah",
            "load_failed": "Nepodařilo se načíst obsah",
            "id": "ID",
            "slug": "Slug",
            "status": "Stav",
            "locale": "Jazyk",
            "likes": "Lajky",
            "dislikes": "Dislajky",
            "completions": "Dokončení",
            "open_in_admin": "Otevřít v administraci"
        },
        "difficulty": {
            "label": "Obtížnost: {{value}}/{{max}}",
            "value": "{{value}}/{{max}}",
            "aria": "Obtížnost {{value}} z {{max}}"
        },
        "detail": {
            "sign_in_to_answer": "Přihlaste se pro odpověď na tuto otázku.",
            "duration": "Trvání: {{minutes}} min",
            "phase": "Fáze {{number}}"
        },
        "list_item": {
            "completions": "{{count}} dokončení",
            "completions_label": "Dokončení: {{count}}"
        },
        "feed": {
            "success": "Správně! 🎉",
            "skip": "Přeskočit",
            "next": "Další",
            "intro_gate": {
                "title": "Přihlas se a pokračuj",
                "body": "Přihlas se nebo si vytvoř účet a Procrastiq se začne přizpůsobovat tomu, co tě baví.",
                "body_more": "Nebude ti zbytečně opakovat stejné otázky, zapamatuje si tvoje výsledky a nabídne ti obsah podle tvých zájmů.",
                "perks": "Navíc získáš přístup k XP, ligám, Survivalu, výzvám s ostatními hráči a dalším funkcím.",
                "register": "Vytvořit účet",
                "login": "Přihlásit se"
            }
        }
    },
    "categories": {
        "title": "Kategorie",
        "filter": "Filtrovat podle kategorie",
        "all": "Vše",
        "loading": "Načítám kategorie...",
        "empty": "Žádné kategorie",
        "expand": "Rozbalit podkategorie",
        "collapse": "Sbalit podkategorie"
    },
    "tags": {
        "title": "Tagy",
        "all": "Vše",
        "loading": "Načítám tagy...",
        "empty": "Žádné tagy"
    },
    "bookmarks": {
        "title": "Uložený obsah",
        "empty": "Zatím nemáte uložený obsah."
    },
    "contribute": {
        "title": "Přispět",
        "subtitle": "Odešlete kvízy ke schválení. Po schválení se objeví ve feedu.",
        "subtitle_reliable": "Jste spolehlivý přispěvatel — vaše kvízy se publikují ihned.",
        "add": "+ Odeslat kvíz",
        "add_first": "Odeslat první kvíz",
        "empty": "Zatím jste neodeslali žádný obsah.",
        "load_failed": "Nepodařilo se načíst váš obsah",
        "cannot_edit_approved": "Schválený obsah může upravit pouze admin.",
        "delete_confirm": "Smazat „{{title}}“?",
        "deleted": "Obsah smazán",
        "delete_failed": "Nepodařilo se smazat obsah",
        "edit": "Upravit",
        "delete": "Smazat",
        "form": {
            "submit_title": "Odeslat kvíz",
            "edit_title": "Upravit kvíz",
            "submit_button": "Odeslat ke schválení",
            "save_button": "Uložit změny",
            "hint": "Váš kvíz bude před zveřejněním ve feedu zkontrolován. Spolehlivým přispěvatelům se publikuje ihned.",
            "success_updated": "Obsah byl úspěšně aktualizován",
            "success_published": "Obsah byl úspěšně publikován",
            "success_submitted": "Obsah byl odeslán ke schválení",
            "success_created": "Obsah byl úspěšně vytvořen",
            "success_translation": "Překlad byl úspěšně vytvořen",
            "failed": "Nepodařilo se {{action}} obsah",
            "action_update": "aktualizovat",
            "action_create": "vytvořit",
            "choose_translation_language": "Vyberte jazyk překladu.",
            "admin_add": "Přidat obsah",
            "admin_edit": "Upravit obsah",
            "admin_add_translation": "Přidat překlad",
            "admin_add_translation_lang": "Přidat překlad ({{lang}})",
            "admin_create": "Vytvořit obsah",
            "admin_update": "Aktualizovat obsah",
            "admin_create_translation": "Vytvořit překlad"
        }
    },
    "content_form": {
        "title": "Název",
        "question": "Otázka",
        "question_placeholder": "Napište celý text otázky",
        "slug": "Slug",
        "language": "Jazyk",
        "difficulty": "Obtížnost (1–5)",
        "country": "Země",
        "status": "Stav",
        "visibility": "Viditelnost",
        "categories": "Kategorie",
        "category": "Kategorie",
        "choose_category": "Vyberte kategorii",
        "tags": "Štítky",
        "translations": "Překlady",
        "translation_new": "(nový)",
        "translate_hint": "Přeložte otázku, možnosti a vysvětlení. Metadata (obtížnost, kategorie, štítky) se zkopírují ze zdroje.",
        "choose_language": "Vyberte jazyk",
        "not_set": "Nenastaveno",
        "options": "Možnosti",
        "option_n": "Možnost {{n}}",
        "correct_answer": "Správná odpověď",
        "explanation": "Vysvětlení",
        "explanation_placeholder": "Volitelné — zobrazí se po špatné odpovědi"
    },
    "user_stats": {
        "title": "Vaše statistiky",
        "sign_in_prompt": "Přihlaste se pro zobrazení statistik",
        "guest_title": "Sbírej XP. Leveluj. Stoupej v ligách.",
        "guest_lead": "Po přihlášení sleduj XP, odemykej hodnosti a soutěž v týdenních ligách.",
        "guest_perk_level": "Získávej XP z kvízů a stoupej po úrovních.",
        "guest_perk_rank": "Odemykej hodnosti podle své úrovně.",
        "guest_perk_league": "Zapoj se do týdenních skupin a postupuj až k Legendární.",
        "xp": "XP",
        "streak": "Série",
        "best_streak": "Nejlepší série",
        "solved": "Odpovězeno",
        "correct": "Správně",
        "accuracy": "Přesnost",
        "bookmarks": "Záložky",
        "contribute": "Přispět",
        "likes": "Lajky",
        "language_mastered": "Zvládnuto",
        "language_learning": "Probíhá",
        "last_7_days": "Posledních 7 dní",
        "days_suffix": "d",
        "no_activity": "Zatím žádná aktivita",
        "weekly_league": "Týdenní liga",
        "league_tiers": "Ligové úrovně",
        "league_tiers_hint": "Úrovně od nejnižší po nejvyšší. Nejlepší ve skupině postupují, nejhorší sestupují.",
        "league_position": "#{{position}} z {{total}} tento týden",
        "view_leaderboard": "Celý žebříček",
        "how_leagues_work": "Jak to funguje",
        "you": "Ty"
    },
    "gamification": {
        "level": "Úroveň",
        "rank": "Hodnost",
        "streak": "Série",
        "daily_goals": "Denní cíle",
        "achievements": "Úspěchy",
        "leaderboard": "Žebříček",
        "season": "Sezóna",
        "xp_to_next": "{{current}} / {{next}} XP do další úrovně",
        "weekly": "Týdenní",
        "monthly": "Tento měsíc",
        "overall": "Celkově",
        "monthly_hint": "Řadí hráče podle soutěžního XP získaného v aktuální měsíční sezóně (stejné klesající výnosy jako u týdenních lig). Není to samostatná ligová úroveň.",
        "overall_hint": "Žebříček podle trvalého celkového XP.",
        "overall_empty": "Na celkovém žebříčku zatím nikdo není.",
        "players": "členů",
        "full_board": "Celý žebříček",
        "player": "Člen",
        "ranked_xp": "Soutěžní XP",
        "total_xp": "Celkové XP",
        "standing": "Postavení",
        "zone": "Postavení",
        "zone_promotion": "Postup",
        "zone_safe": "Bezpečně",
        "zone_relegation": "Sestup",
        "zone_legend": "Nejlepších {{promo}} postupuje · nejhorších {{releg}} sestupuje na konci týdne.",
        "unlocked": "Odemčeno",
        "achievements_error": "Nepodařilo se načíst úspěchy",
        "achievements_intro": "Odemykáte odznaky za hraní — aktivitu, přesnost, série, obtížnost a učení z chyb.",
        "achievement_categories": {
            "activity": "Aktivita",
            "correct_answers": "Správné odpovědi",
            "learning_from_mistakes": "Učení z chyb",
            "streaks": "Série",
            "difficulty": "Obtížnost",
            "variety": "Rozmanitost",
            "general": "Obecné"
        },
        "achievement_category_hints": {
            "learning_from_mistakes": "Po špatné odpovědi se kvíz může později vrátit k procvičení. Teprve správná odpověď při tom opakování se počítá sem."
        },
        "your_rank": "Tvoje pozice",
        "around_you": "Kolem tebe",
        "tooltip_total_xp": "{{xp}} XP",
        "tooltip_level": "Úroveň {{level}}",
        "weekly_waiting": "Nepodařilo se načíst týdenní skupinu. Zkus to prosím znovu.",
        "weekly_ineligible": "Hraj dál a odemkni týdenní ligy.",
        "achievements_progress": "{{unlocked}} / {{total}} odemčeno",
        "toast": {
            "xp_gained": "+{{xp}} XP",
            "achievement": "Úspěch odemčen: {{name}}"
        },
        "level_up": {
            "title": "Nová úroveň!",
            "body": "Dosáhl jsi úrovně {{level}}",
            "continue": "Pokračovat"
        }
    },
    "creator": {
        "rank": "Tvůrčí hodnost",
        "xp": "Tvůrčí XP",
        "tooltip_rank": "{{rank}}",
        "tooltip_cxp": "{{xp}} CXP",
        "approved": "Schválené příspěvky",
        "views": "Zobrazení",
        "completions": "Dokončení",
        "likes": "Lajky",
        "bookmarks": "Záložky",
        "top_contribution": "Nejlepší příspěvek",
        "newest_contribution": "Nejnovější příspěvek",
        "to_next": "do další hodnosti",
        "players_board": "Členové",
        "creators_board": "Přispěvatelé",
        "board_group": "Typ žebříčku",
        "weekly": "Týdenní",
        "monthly": "Měsíční",
        "all_time": "Celkově",
        "weekly_hint": "Tvůrci podle tvůrčího XP získaného tento týden.",
        "monthly_hint": "Tvůrci podle tvůrčího XP získaného tento měsíc.",
        "all_time_hint": "Žebříček podle celkového tvůrčího XP.",
        "empty": "Na tvůrčím žebříčku zatím nikdo není."
    },
    "profile": {
        "title": "Můj profil",
        "edit": {
            "title": "Upravit profil"
        },
        "nav": {
            "label": "Účet",
            "overview": "Přehled",
            "stats": "Statistiky",
            "leagues": "Ligy",
            "edit": "Upravit profil",
            "contribute": "Přispět",
            "bookmarks": "Záložky",
            "achievements": "Úspěchy",
            "leaderboards": "Žebříčky",
            "browse": "Procházet obsah"
        },
        "actions": {
            "back_to_home": "Zpět na úvod",
            "back_to_profile": "Zpět na profil",
            "edit": "Upravit profil",
            "contribute": "Přispět"
        },
        "labels": {
            "initials": "Iniciály",
            "role": "Role",
            "status": "Stav",
            "sign_in_method": "Způsob přihlášení",
            "member_since": "Členem od",
            "country": "Země",
            "reliable": "Spolehlivý přispěvatel"
        },
        "sections": {
            "account_info": "Informace o účtu",
            "authentication": "Ověření",
            "creator": "Tvůrce",
            "stats": "Tvoje statistiky",
            "leagues": "Týdenní ligy"
        },
        "stats": {
            "title": "Statistiky",
            "subtitle": "Tvůj postup, aktivita a týdenní liga na jednom místě.",
            "empty": "Zatím žádné statistiky. Zahraj pár kvízů a začni.",
            "periods": "Dnes a tento týden",
            "today": "Dnes",
            "see_all": "Všechny statistiky",
            "see_leagues": "Otevřít stránku lig"
        },
        "leagues": {
            "title": "Ligy",
            "subtitle": "Tvoje týdenní ligová úroveň, pozice ve skupině a zóna postupu nebo sestupu.",
            "your_group": "Tvoje skupina tento týden",
            "see_all": "Otevřít ligy"
        }
    },
    "notifications": {
        "title": "Notifikace",
        "hint": "Dostávej upozornění na sérii, pozici v lize a svůj obsah — i když je Procrastiq zavřený.",
        "enable": "Zapnout notifikace",
        "disable": "Vypnout na tomto zařízení",
        "enabled": "Notifikace zapnuty",
        "disabled": "Notifikace na tomto zařízení vypnuty",
        "enable_failed": "Notifikace se nepodařilo zapnout",
        "disable_failed": "Notifikace se nepodařilo vypnout",
        "prefs_failed": "Nastavení se nepodařilo uložit",
        "unsupported": "Tento prohlížeč nepodporuje push notifikace.",
        "pref_ranking": "Liga a žebříček",
        "pref_streak": "Série",
        "pref_reactions": "Reakce na můj obsah",
        "pref_approved": "Schválení obsahu"
    },
    "games": {
        "challenge_friend": "Vyzvi kamaráda",
        "survival_mode": "Survival",
        "challenges_inbox": "Výzvy",
        "view_inbox": "Přehled výzev",
        "pick_friend": "Vyber kamaráda",
        "random_opponent": "Náhodný soupeř",
        "search_users": "Hledej podle jména…",
        "search_error": "Vyhledávání uživatelů selhalo",
        "selected": "Vybráno",
        "selected_opponent": "Vybraný hráč",
        "pick_opponent": "Nejdřív vyber soupeře",
        "random_hint": "Spárujeme tě s aktivním hráčem.",
        "any_category": "Libovolná kategorie",
        "category_optional": "Kategorie (volitelné)",
        "start_challenge": "Odeslat výzvu",
        "challenge_created": "Výzva odeslána!",
        "create_error": "Výzvu se nepodařilo vytvořit",
        "challenge": "Výzva",
        "open": "Otevřít",
        "new_challenge": "Nová výzva",
        "start_playing": "Začít hrát",
        "accept_play": "Přijmout a hrát",
        "decline": "Odmítnout",
        "decline_error": "Výzvu se nepodařilo odmítnout",
        "your_result": "Tvůj výsledek",
        "opponent_result": "Soupeř",
        "waiting_opponent": "Čeká se, až soupeř dokončí…",
        "score_line": "{{correct}}/{{total}} správně · {{time}}",
        "you_won": "Vyhrál jsi!",
        "you_lost": "Prohrál jsi",
        "draw": "Remíza",
        "submitting": "Odesílám odpovědi…",
        "submit_error": "Odeslání výzvy selhalo",
        "load_error": "Načtení selhalo",
        "not_found": "Výzva nenalezena",
        "no_challenges": "Zatím žádné výzvy",
        "incoming": "Příchozí",
        "outgoing": "Odchozí",
        "player": "Hráč",
        "filter": {
            "incoming": "Příchozí",
            "outgoing": "Odchozí",
            "all": "Vše"
        },
        "status": {
            "pending": "Čeká",
            "in_progress": "Probíhá",
            "completed": "Dokončeno",
            "declined": "Odmítnuto",
            "expired": "Vypršelo"
        },
        "question_progress": "Otázka {{current}} / {{total}}",
        "time_left": "{{seconds}} s",
        "elapsed_time": "Čas {{time}}",
        "overall_time": "Celkový čas",
        "total_time_left": "Celkem {{seconds}} s",
        "no_options": "U této otázky nejsou možnosti",
        "survival_leaderboard": "Survival žebříček",
        "survival_leaderboard_hint": "Nejlepší survival run hráče ve zvoleném období.",
        "survival_empty": "Zatím žádné skóre — buď první!",
        "play_survival": "Hrát Survival",
        "current_score": "Skóre: {{score}}",
        "game_over": "Konec hry",
        "final_score": "Skóre: {{score}}",
        "personal_best": "Osobní rekord: {{score}}",
        "daily_rank": "Denní pořadí: #{{rank}}",
        "weekly_rank": "Týdenní pořadí: #{{rank}}",
        "play_again": "Hrát znovu",
        "survival_start_error": "Survival se nepodařilo spustit",
        "survival_error": "Chyba Survival módu",
        "daily": "Denně",
        "weekly": "Týdně",
        "all_time": "Celkově",
        "score": "Skóre",
        "challenge_user": "Vyzvat {{name}}",
        "login_to_challenge": "Pro výzvu se přihlas",
        "profile_error": "Profil se nepodařilo načíst",
        "profile_not_found": "Hráč nenalezen",
        "profile": "Profil",
        "notifications": "Notifikace",
        "mark_all_read": "Označit vše jako přečtené",
        "no_notifications": "Žádné notifikace",
        "blocked_users": "Blokovaní hráči",
        "blocked_hint": "Blokovaní hráči tě nemohou vyzvat.",
        "no_blocked": "Nikoho nemáš zablokovaného.",
        "unblock": "Odblokovat",
        "unblocked": "Hráč odblokován",
        "unblock_error": "Odblokování selhalo",
        "blocked_load_error": "Seznam blokovaných se nepodařilo načíst",
        "survival_howto": "Odpovídej správně co nejdéle. Na každou otázku máš 20 sekund. Jednu špatnou odpověď ti odpustíme — druhá chyba hru ukončí. Skóre je počet správných odpovědí.",
        "challenge_howto": "Deset otázek, na každou 20 sekund. Čím víc správných odpovědí a čím rychleji, tím lépe. Soupeřův výsledek uvidíš, až budete hotoví oba.",
        "continue": "Pokračovat",
        "survival_reserve": "Rezerva: {{count}}",
        "survival_second_chance": "Ještě jedna šance!",
        "guest_teaser": "Přihlas se a vyzývej kamarády nebo hraj Survival."
    },
    "logo": {
        "title": "ProcrastiQ",
        "slogan": "Chytré přestávky pro váš mozek"
    }
};
